<div class="list-wrapper">
  <kgrid  #grid
       [apiName]="apiName"
       [areaName]="areaName"
       [label]="label"
       [name]="apiName"
       [VoucherKindIdName]="'VoucherKindId'"
       [isModal]="false"
       [isMulti]="true"
       [isMultiDelete]="true"
       [actions]="actions"
       [actionTregger]="onActionClick"
       [unSortableFilterable]="unSortableFilterable"
       reportName="InventoryList"
       pathPreFix="INV"
       defaultSortKey="ShamsiVoucherDate"
       defaultSortKeyKind="desc"
       [filters]="filters"
       [defaultFilterKey]="filterInfo"
       [isAdd]="false"
       [inputEditorform]="inputEditorform"
       [customExportExcelUrl]="'InvVoucherHeader/ExportExcel'"
       [getParamsForExportExcelWithPostMethod]="getParamsForExportExcelWithPostMethod.bind(this)">
</kgrid>
</div>

